export const LEAVE_INFORMATION_INITIAL = [
    { leave_type_id: "", start_date: "", end_date: "" },
  ]